// The round length comes from the server's round message (`seconds`); 60 only for a message without it (demo rounds).
export const roundSeconds = round => (round?.seconds > 0 ? round.seconds : 60);
// The 60-tick desktop bar: the share of the round left, whatever its length.
export const barTicks = (secsLeft, total) => Math.max(0, Math.min(60, Math.ceil(secsLeft * 60 / total)));
